import { createFileRoute } from '@tanstack/react-router'
import { IntegrationsPage } from '@/pages/integrations'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations'
)({
  component: IntegrationsPage,
  staticData: {
    pageHeader: { title: 'Integrations', customHeader: true, pad: false },
  },
})
